/* eslint-disable */
export default {
  Home: 'Domicile',
  Mobile: 'Cellulaire',
  Work: 'Bureau',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
